import { render } from "./UpcomingAssignmentsCard.vue?vue&type=template&id=02553e50&scoped=true"
import script from "./UpcomingAssignmentsCard.vue?vue&type=script&lang=js"
export * from "./UpcomingAssignmentsCard.vue?vue&type=script&lang=js"

import "./UpcomingAssignmentsCard.vue?vue&type=style&index=0&id=02553e50&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02553e50"]])

export default __exports__